import { render, staticRenderFns } from "./all-faculty-workloads.vue?vue&type=template&id=67761b82&scoped=true&"
import script from "./all-faculty-workloads.vue?vue&type=script&lang=js&"
export * from "./all-faculty-workloads.vue?vue&type=script&lang=js&"
import style0 from "./all-faculty-workloads.vue?vue&type=style&index=0&id=67761b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67761b82",
  null
  
)

export default component.exports